/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AllowedDenied,
    AllowedDeniedFromJSON,
    AllowedDeniedFromJSONTyped,
    AllowedDeniedToJSON,
    PermissionListItem,
    PermissionListItemFromJSON,
    PermissionListItemFromJSONTyped,
    PermissionListItemToJSON,
    SectionPermission,
    SectionPermissionFromJSON,
    SectionPermissionFromJSONTyped,
    SectionPermissionToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserPermissionsFormData
 */
export interface UserPermissionsFormData {
    /**
     * 
     * @type {AllowedDenied}
     * @memberof UserPermissionsFormData
     */
    adminPortal?: AllowedDenied;
    /**
     * 
     * @type {SectionPermission}
     * @memberof UserPermissionsFormData
     */
    userPermissions?: SectionPermission;
    /**
     * 
     * @type {Array<PermissionListItem>}
     * @memberof UserPermissionsFormData
     */
    searchManager?: Array<PermissionListItem> | null;
    /**
     * 
     * @type {AllowedDenied}
     * @memberof UserPermissionsFormData
     */
    searchManagerDiagnostics?: AllowedDenied;
    /**
     * 
     * @type {AllowedDenied}
     * @memberof UserPermissionsFormData
     */
    markupDiagnostics?: AllowedDenied;
    /**
     * 
     * @type {AllowedDenied}
     * @memberof UserPermissionsFormData
     */
    globalFilterDiagnostics?: AllowedDenied;
    /**
     * 
     * @type {Array<PermissionListItem>}
     * @memberof UserPermissionsFormData
     */
    bookingCreateManagerOsis?: Array<PermissionListItem> | null;
    /**
     * 
     * @type {Array<PermissionListItem>}
     * @memberof UserPermissionsFormData
     */
    bookingCreateManagerRemarks?: Array<PermissionListItem> | null;
    /**
     * 
     * @type {SectionPermission}
     * @memberof UserPermissionsFormData
     */
    regions?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof UserPermissionsFormData
     */
    countries?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof UserPermissionsFormData
     */
    cities?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof UserPermissionsFormData
     */
    airports?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof UserPermissionsFormData
     */
    airlines?: SectionPermission;
    /**
     * 
     * @type {Array<PermissionListItem>}
     * @memberof UserPermissionsFormData
     */
    agencies?: Array<PermissionListItem> | null;
    /**
     * 
     * @type {Array<PermissionListItem>}
     * @memberof UserPermissionsFormData
     */
    agencyGroups?: Array<PermissionListItem> | null;
    /**
     * 
     * @type {Array<PermissionListItem>}
     * @memberof UserPermissionsFormData
     */
    providerCredentials?: Array<PermissionListItem> | null;
    /**
     * 
     * @type {Array<PermissionListItem>}
     * @memberof UserPermissionsFormData
     */
    providerPreferences?: Array<PermissionListItem> | null;
    /**
     * 
     * @type {Array<PermissionListItem>}
     * @memberof UserPermissionsFormData
     */
    identityProviderSettings?: Array<PermissionListItem> | null;
    /**
     * 
     * @type {Array<PermissionListItem>}
     * @memberof UserPermissionsFormData
     */
    identitySettings?: Array<PermissionListItem> | null;
    /**
     * 
     * @type {Array<PermissionListItem>}
     * @memberof UserPermissionsFormData
     */
    markups?: Array<PermissionListItem> | null;
    /**
     * 
     * @type {Array<PermissionListItem>}
     * @memberof UserPermissionsFormData
     */
    ticketTLO?: Array<PermissionListItem> | null;
    /**
     * 
     * @type {AllowedDenied}
     * @memberof UserPermissionsFormData
     */
    shoppingDiagnostics?: AllowedDenied;
    /**
     * 
     * @type {AllowedDenied}
     * @memberof UserPermissionsFormData
     */
    technicalLogs?: AllowedDenied;
    /**
     * 
     * @type {SectionPermission}
     * @memberof UserPermissionsFormData
     */
    brands?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof UserPermissionsFormData
     */
    markets?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof UserPermissionsFormData
     */
    distributionChannels?: SectionPermission;
    /**
     * 
     * @type {Array<PermissionListItem>}
     * @memberof UserPermissionsFormData
     */
    globalFilters?: Array<PermissionListItem> | null;
    /**
     * 
     * @type {AllowedDenied}
     * @memberof UserPermissionsFormData
     */
    activityLog?: AllowedDenied;
    /**
     * 
     * @type {SectionPermission}
     * @memberof UserPermissionsFormData
     */
    supplierLocationMappings?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof UserPermissionsFormData
     */
    providers?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof UserPermissionsFormData
     */
    ancillarySuppliers?: SectionPermission;
    /**
     * 
     * @type {Array<PermissionListItem>}
     * @memberof UserPermissionsFormData
     */
    ancillaryDistributions?: Array<PermissionListItem> | null;
    /**
     * 
     * @type {Array<PermissionListItem>}
     * @memberof UserPermissionsFormData
     */
    vccCredentials?: Array<PermissionListItem> | null;
    /**
     * 
     * @type {Array<PermissionListItem>}
     * @memberof UserPermissionsFormData
     */
    ssrRules?: Array<PermissionListItem> | null;
    /**
     * 
     * @type {Array<PermissionListItem>}
     * @memberof UserPermissionsFormData
     */
    bookingTolerances?: Array<PermissionListItem> | null;
    /**
     * 
     * @type {SectionPermission}
     * @memberof UserPermissionsFormData
     */
    ancillaryManager?: SectionPermission;
}

export function UserPermissionsFormDataFromJSON(json: any): UserPermissionsFormData {
    return UserPermissionsFormDataFromJSONTyped(json, false);
}

export function UserPermissionsFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPermissionsFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'adminPortal': !exists(json, 'adminPortal') ? undefined : AllowedDeniedFromJSON(json['adminPortal']),
        'userPermissions': !exists(json, 'userPermissions') ? undefined : SectionPermissionFromJSON(json['userPermissions']),
        'searchManager': !exists(json, 'searchManager') ? undefined : (json['searchManager'] === null ? null : (json['searchManager'] as Array<any>).map(PermissionListItemFromJSON)),
        'searchManagerDiagnostics': !exists(json, 'searchManagerDiagnostics') ? undefined : AllowedDeniedFromJSON(json['searchManagerDiagnostics']),
        'markupDiagnostics': !exists(json, 'markupDiagnostics') ? undefined : AllowedDeniedFromJSON(json['markupDiagnostics']),
        'globalFilterDiagnostics': !exists(json, 'globalFilterDiagnostics') ? undefined : AllowedDeniedFromJSON(json['globalFilterDiagnostics']),
        'bookingCreateManagerOsis': !exists(json, 'bookingCreateManagerOsis') ? undefined : (json['bookingCreateManagerOsis'] === null ? null : (json['bookingCreateManagerOsis'] as Array<any>).map(PermissionListItemFromJSON)),
        'bookingCreateManagerRemarks': !exists(json, 'bookingCreateManagerRemarks') ? undefined : (json['bookingCreateManagerRemarks'] === null ? null : (json['bookingCreateManagerRemarks'] as Array<any>).map(PermissionListItemFromJSON)),
        'regions': !exists(json, 'regions') ? undefined : SectionPermissionFromJSON(json['regions']),
        'countries': !exists(json, 'countries') ? undefined : SectionPermissionFromJSON(json['countries']),
        'cities': !exists(json, 'cities') ? undefined : SectionPermissionFromJSON(json['cities']),
        'airports': !exists(json, 'airports') ? undefined : SectionPermissionFromJSON(json['airports']),
        'airlines': !exists(json, 'airlines') ? undefined : SectionPermissionFromJSON(json['airlines']),
        'agencies': !exists(json, 'agencies') ? undefined : (json['agencies'] === null ? null : (json['agencies'] as Array<any>).map(PermissionListItemFromJSON)),
        'agencyGroups': !exists(json, 'agencyGroups') ? undefined : (json['agencyGroups'] === null ? null : (json['agencyGroups'] as Array<any>).map(PermissionListItemFromJSON)),
        'providerCredentials': !exists(json, 'providerCredentials') ? undefined : (json['providerCredentials'] === null ? null : (json['providerCredentials'] as Array<any>).map(PermissionListItemFromJSON)),
        'providerPreferences': !exists(json, 'providerPreferences') ? undefined : (json['providerPreferences'] === null ? null : (json['providerPreferences'] as Array<any>).map(PermissionListItemFromJSON)),
        'identityProviderSettings': !exists(json, 'identityProviderSettings') ? undefined : (json['identityProviderSettings'] === null ? null : (json['identityProviderSettings'] as Array<any>).map(PermissionListItemFromJSON)),
        'identitySettings': !exists(json, 'identitySettings') ? undefined : (json['identitySettings'] === null ? null : (json['identitySettings'] as Array<any>).map(PermissionListItemFromJSON)),
        'markups': !exists(json, 'markups') ? undefined : (json['markups'] === null ? null : (json['markups'] as Array<any>).map(PermissionListItemFromJSON)),
        'ticketTLO': !exists(json, 'ticketTLO') ? undefined : (json['ticketTLO'] === null ? null : (json['ticketTLO'] as Array<any>).map(PermissionListItemFromJSON)),
        'shoppingDiagnostics': !exists(json, 'shoppingDiagnostics') ? undefined : AllowedDeniedFromJSON(json['shoppingDiagnostics']),
        'technicalLogs': !exists(json, 'technicalLogs') ? undefined : AllowedDeniedFromJSON(json['technicalLogs']),
        'brands': !exists(json, 'brands') ? undefined : SectionPermissionFromJSON(json['brands']),
        'markets': !exists(json, 'markets') ? undefined : SectionPermissionFromJSON(json['markets']),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : SectionPermissionFromJSON(json['distributionChannels']),
        'globalFilters': !exists(json, 'globalFilters') ? undefined : (json['globalFilters'] === null ? null : (json['globalFilters'] as Array<any>).map(PermissionListItemFromJSON)),
        'activityLog': !exists(json, 'activityLog') ? undefined : AllowedDeniedFromJSON(json['activityLog']),
        'supplierLocationMappings': !exists(json, 'supplierLocationMappings') ? undefined : SectionPermissionFromJSON(json['supplierLocationMappings']),
        'providers': !exists(json, 'providers') ? undefined : SectionPermissionFromJSON(json['providers']),
        'ancillarySuppliers': !exists(json, 'ancillarySuppliers') ? undefined : SectionPermissionFromJSON(json['ancillarySuppliers']),
        'ancillaryDistributions': !exists(json, 'ancillaryDistributions') ? undefined : (json['ancillaryDistributions'] === null ? null : (json['ancillaryDistributions'] as Array<any>).map(PermissionListItemFromJSON)),
        'vccCredentials': !exists(json, 'vccCredentials') ? undefined : (json['vccCredentials'] === null ? null : (json['vccCredentials'] as Array<any>).map(PermissionListItemFromJSON)),
        'ssrRules': !exists(json, 'ssrRules') ? undefined : (json['ssrRules'] === null ? null : (json['ssrRules'] as Array<any>).map(PermissionListItemFromJSON)),
        'bookingTolerances': !exists(json, 'bookingTolerances') ? undefined : (json['bookingTolerances'] === null ? null : (json['bookingTolerances'] as Array<any>).map(PermissionListItemFromJSON)),
        'ancillaryManager': !exists(json, 'ancillaryManager') ? undefined : SectionPermissionFromJSON(json['ancillaryManager']),
    };
}

export function UserPermissionsFormDataToJSON(value?: UserPermissionsFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'adminPortal': AllowedDeniedToJSON(value.adminPortal),
        'userPermissions': SectionPermissionToJSON(value.userPermissions),
        'searchManager': value.searchManager === undefined ? undefined : (value.searchManager === null ? null : (value.searchManager as Array<any>).map(PermissionListItemToJSON)),
        'searchManagerDiagnostics': AllowedDeniedToJSON(value.searchManagerDiagnostics),
        'markupDiagnostics': AllowedDeniedToJSON(value.markupDiagnostics),
        'globalFilterDiagnostics': AllowedDeniedToJSON(value.globalFilterDiagnostics),
        'bookingCreateManagerOsis': value.bookingCreateManagerOsis === undefined ? undefined : (value.bookingCreateManagerOsis === null ? null : (value.bookingCreateManagerOsis as Array<any>).map(PermissionListItemToJSON)),
        'bookingCreateManagerRemarks': value.bookingCreateManagerRemarks === undefined ? undefined : (value.bookingCreateManagerRemarks === null ? null : (value.bookingCreateManagerRemarks as Array<any>).map(PermissionListItemToJSON)),
        'regions': SectionPermissionToJSON(value.regions),
        'countries': SectionPermissionToJSON(value.countries),
        'cities': SectionPermissionToJSON(value.cities),
        'airports': SectionPermissionToJSON(value.airports),
        'airlines': SectionPermissionToJSON(value.airlines),
        'agencies': value.agencies === undefined ? undefined : (value.agencies === null ? null : (value.agencies as Array<any>).map(PermissionListItemToJSON)),
        'agencyGroups': value.agencyGroups === undefined ? undefined : (value.agencyGroups === null ? null : (value.agencyGroups as Array<any>).map(PermissionListItemToJSON)),
        'providerCredentials': value.providerCredentials === undefined ? undefined : (value.providerCredentials === null ? null : (value.providerCredentials as Array<any>).map(PermissionListItemToJSON)),
        'providerPreferences': value.providerPreferences === undefined ? undefined : (value.providerPreferences === null ? null : (value.providerPreferences as Array<any>).map(PermissionListItemToJSON)),
        'identityProviderSettings': value.identityProviderSettings === undefined ? undefined : (value.identityProviderSettings === null ? null : (value.identityProviderSettings as Array<any>).map(PermissionListItemToJSON)),
        'identitySettings': value.identitySettings === undefined ? undefined : (value.identitySettings === null ? null : (value.identitySettings as Array<any>).map(PermissionListItemToJSON)),
        'markups': value.markups === undefined ? undefined : (value.markups === null ? null : (value.markups as Array<any>).map(PermissionListItemToJSON)),
        'ticketTLO': value.ticketTLO === undefined ? undefined : (value.ticketTLO === null ? null : (value.ticketTLO as Array<any>).map(PermissionListItemToJSON)),
        'shoppingDiagnostics': AllowedDeniedToJSON(value.shoppingDiagnostics),
        'technicalLogs': AllowedDeniedToJSON(value.technicalLogs),
        'brands': SectionPermissionToJSON(value.brands),
        'markets': SectionPermissionToJSON(value.markets),
        'distributionChannels': SectionPermissionToJSON(value.distributionChannels),
        'globalFilters': value.globalFilters === undefined ? undefined : (value.globalFilters === null ? null : (value.globalFilters as Array<any>).map(PermissionListItemToJSON)),
        'activityLog': AllowedDeniedToJSON(value.activityLog),
        'supplierLocationMappings': SectionPermissionToJSON(value.supplierLocationMappings),
        'providers': SectionPermissionToJSON(value.providers),
        'ancillarySuppliers': SectionPermissionToJSON(value.ancillarySuppliers),
        'ancillaryDistributions': value.ancillaryDistributions === undefined ? undefined : (value.ancillaryDistributions === null ? null : (value.ancillaryDistributions as Array<any>).map(PermissionListItemToJSON)),
        'vccCredentials': value.vccCredentials === undefined ? undefined : (value.vccCredentials === null ? null : (value.vccCredentials as Array<any>).map(PermissionListItemToJSON)),
        'ssrRules': value.ssrRules === undefined ? undefined : (value.ssrRules === null ? null : (value.ssrRules as Array<any>).map(PermissionListItemToJSON)),
        'bookingTolerances': value.bookingTolerances === undefined ? undefined : (value.bookingTolerances === null ? null : (value.bookingTolerances as Array<any>).map(PermissionListItemToJSON)),
        'ancillaryManager': SectionPermissionToJSON(value.ancillaryManager),
    };
}


